import React from "react";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DateSelector = ({
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
}) => {
  return (
    <div className="flex items-center gap-3 bg-white border rounded-lg shadow px-3 py-1">
      {/* Month Selector */}
      <div className="flex items-center gap-1">
        <button
          onClick={() =>
            setSelectedMonth((prev) => (prev === 1 ? 12 : prev - 1))
          }
          className="p-1 hover:bg-gray-100 rounded"
        >
          ◀
        </button>
        <span className="px-2 text-sm font-medium">
          {months[selectedMonth - 1]}
        </span>
        <button
          onClick={() =>
            setSelectedMonth((prev) => (prev === 12 ? 1 : prev + 1))
          }
          className="p-1 hover:bg-gray-100 rounded"
        >
          ▶
        </button>
      </div>
      <span className="border-l h-5"></span> {/* Divider */}
      {/* Year Selector */}
      <div className="flex items-center gap-1">
        <button
          onClick={() => setSelectedYear((prev) => prev - 1)}
          className="p-1 hover:bg-gray-100 rounded"
        >
          ◀
        </button>
        <span className="px-2 text-sm font-medium">{selectedYear}</span>
        <button
          onClick={() => setSelectedYear((prev) => prev + 1)}
          className="p-1 hover:bg-gray-100 rounded"
        >
          ▶
        </button>
      </div>
    </div>
  );
};

export default DateSelector;
